export default __webpack_public_path__ + "static/banner-pocket-ce4e2ff37f0efa64072ae6daf54d2e35.svg";